import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VDialog,
    {
      attrs: { fullscreen: "", transition: "dialog-bottom-transition" },
      scopedSlots: _vm._u(
        [
          {
            key: "activator",
            fn: function ({ on, attrs }) {
              return [
                _vm._t(
                  "activator",
                  function () {
                    return [
                      _c(
                        VBtn,
                        {
                          attrs: { outlined: "", color: "primary" },
                          on: { click: _vm.onOpen },
                        },
                        [
                          _c(VIcon, [_vm._v(" mdi-file-outline ")]),
                          _vm._v(
                            " " + _vm._s(_vm.$t("common.open")) + "\n      "
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  { action: _vm.onOpen },
                  attrs
                ),
              ]
            },
          },
        ],
        null,
        true
      ),
      model: {
        value: _vm.showDialog,
        callback: function ($$v) {
          _vm.showDialog = $$v
        },
        expression: "showDialog",
      },
    },
    [
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.getValue[_vm.current] &&
        _vm.showToolbar &&
        _vm.showHeaderByContentType(_vm.getValue[_vm.current])
          ? _c(
              "div",
              {
                staticClass: "media-viewer-header d-flex align-center",
                style: {
                  color: _vm.textColor,
                  backgroundColor: _vm.toolbarColor,
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "flex--1" },
                  [
                    _vm._t(
                      "infoContainer",
                      function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "d-flex",
                              staticStyle: { color: "white" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "text-truncate text-h5" },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.getValue[_vm.current].name) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.getValue[_vm.current]["content-length"] !==
                              undefined
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "flex-shrink-0 ml-2 text-h5",
                                    },
                                    [
                                      _vm._v(
                                        "\n              (" +
                                          _vm._s(
                                            _vm._f("prettyBytes")(
                                              _vm.getValue[_vm.current][
                                                "content-length"
                                              ]
                                            )
                                          ) +
                                          ")\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      },
                      {
                        textColor: _vm.textColor,
                        item: _vm.getValue[_vm.current],
                      }
                    ),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex--0" },
                  [
                    _vm._t(
                      "closeButton",
                      function () {
                        return [
                          _c(
                            VBtn,
                            {
                              attrs: {
                                icon: "",
                                color: "primary",
                                "x-large": "",
                              },
                              on: { click: _vm.onClose },
                            },
                            [_c(VIcon, [_vm._v("mdi-close")])],
                            1
                          ),
                        ]
                      },
                      { action: _vm.onClose }
                    ),
                  ],
                  2
                ),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "content-style",
          style: { backgroundColor: _vm.backgroundHexa },
          on: {
            click: function ($event) {
              _vm.showToolbar = !_vm.showToolbar
            },
          },
        },
        [
          _c(
            "CarouselWrapper",
            _vm._g(
              _vm._b(
                {
                  key: _vm.carouselWrapperKey,
                  staticClass: "carousel-wrapper",
                  attrs: {
                    "hide-document-name": "",
                    height: _vm.$vuetify.breakpoint.height,
                    "current-item": _vm.current,
                    "show-arrows": !_vm.$vuetify.breakpoint.mobile,
                  },
                  on: {
                    "update:currentItem": function ($event) {
                      _vm.current = $event
                    },
                    "update:current-item": function ($event) {
                      _vm.current = $event
                    },
                  },
                  model: {
                    value: _vm.getValue,
                    callback: function ($$v) {
                      _vm.getValue = $$v
                    },
                    expression: "getValue",
                  },
                },
                "CarouselWrapper",
                _vm.$attrs,
                false
              ),
              _vm.$listeners
            )
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.getValue[_vm.current] &&
        _vm.showToolbar &&
        _vm.showFooterByContentType(_vm.getValue[_vm.current])
          ? _c(
              "div",
              {
                staticClass: "media-viewer-footer",
                style: { backgroundColor: _vm.toolbarColor },
              },
              [
                _c(
                  VRow,
                  { staticClass: "mh-78px overflow-hidden" },
                  [
                    _c(
                      VCol,
                      {
                        staticClass: "text-center",
                        staticStyle: { color: "white" },
                        attrs: { cols: "4", offset: "4" },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "text-h5",
                            style: { color: _vm.textColor },
                          },
                          [
                            _vm._v(
                              "\n            (" +
                                _vm._s(_vm.current + 1) +
                                "/" +
                                _vm._s(_vm.getValue.length) +
                                ")\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      VCol,
                      { staticClass: "text-right", attrs: { cols: "4" } },
                      [
                        _vm.showDownloadButton
                          ? _vm._t(
                              "downloadButton",
                              function () {
                                return [
                                  _c(
                                    VBtn,
                                    {
                                      attrs: { color: "primary", icon: "" },
                                      on: { click: _vm.download },
                                    },
                                    [
                                      _c(VIcon, { attrs: { size: "50" } }, [
                                        _vm._v(
                                          "\n                mdi-download\n              "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              { action: _vm.download }
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }